import { render, staticRenderFns } from "./OrderActionArchive.vue?vue&type=template&id=36ca6d0f&"
import script from "./OrderActionArchive.vue?vue&type=script&lang=ts&"
export * from "./OrderActionArchive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports